import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Old DMS-era URLs (.asp/.aspx/.htm) 301'd here client-side to the closest new section.
const RULES = [
  [/thedms\.aspx?|[?&]venue=\d+/i, '/explore'],
  [/^\/(see-and-do|things-to-do|attractions|history-and-heritage|food-and-drink)\b/i, '/explore'],
  [/^\/(whats-on|events)\b/i, '/events'],
  [/^\/trade\b/i, '/partners'],
  [/^\/(accommodation|where-to-stay|places-to-stay)\b/i, '/accommodation'],
  [/^\/(meltonmowbray|melton-mowbray|melton)\b/i, '/towns/melton-mowbray'],
  [/^\/(loughborough|charnwood)\b/i, '/towns/loughborough-charnwood'],
  [/^\/(hinckley|market-bosworth)\b/i, '/towns/hinckley-market-bosworth'],
  [/^\/(ashby|ashby-de-la-zouch|coalville)\b/i, '/towns/ashby-de-la-zouch-coalville'],
  [/^\/leicester\b/i, '/towns/leicester'],
  [/^\/news\b/i, '/'],
];

export const legacyTarget = (pathname, search = '') => {
  const full = pathname + search;
  const isLegacy = /\.(aspx?|html?)(\?|$)/i.test(pathname) || /thedms/i.test(full) || /[?&](dms|venue|GroupId)=/i.test(full);
  if (!isLegacy) return null;
  for (const [re, to] of RULES) {
    if (re.test(full) || re.test(pathname)) return to;
  }
  // Unmappable legacy URL: fall through to the 404 page (noindex) instead of
  // rendering the homepage at a stale URL — that pattern is what Google
  // flags as a "Soft 404".
  return null;
};

export default function LegacyRedirect() {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const to = legacyTarget(pathname, search);
    if (to && to !== pathname) navigate(to, { replace: true });
  }, [pathname, search, navigate]);
  return null;
}
